import actionTypes from 'domain/shipment/factoryUpload/actionTypes';

const initialState = {
  isBatchingOrders: false,
  isBatchedSuccessfully: false,
  batchedSalesOrders: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.BATCH_SALES_ORDERS:
      return {
        ...state,
        isBatchingOrders: true,
      };
    case actionTypes.BATCHED_SALES_ORDERS:
      return {
        ...state,
        batchedSalesOrders: action.payload.data,
        isBatchingOrders: false,
      };
    case actionTypes.BATCHED_SUCCESSFULLY:
      console.log({ state: state.isBatchedSuccessfully });
      return {
        ...state,
        isBatchedSuccessfully: !state.isBatchedSuccessfully,
        isBatchingOrders: false,
      };

    default:
      return state;
  }
};
